module.exports = __webpack_public_path__ + "static/media/guadeloupe.7a4e5a7f.svg";